import { TableConfig, ModeType, ResizeType, DisplayType, ExportType, ExportActionType, FilterType } from "../../../../../models/common/table/table-config";
import { ExcelExportService } from "../../../../../state/core/services/excel-export/excel-export.service";
import { TableColumnUtil } from "../../../../../core/utils/table-column-utils";

/**
 * Table Config for the user request list for business Component
 */
export const DEVICE_INFO_TABLE_CONSTANT: TableConfig = {
    rows: 20,
    paginator: true,
    lazy: true,
    sortMode: ModeType.SINGLE,
    reorderableColumns: true,
    filterable: false,
    resizableColumns: true,
    scrollable: true,
    scrollHeight: 'calc(100vh - 260px)',
    fullPageHeight: true,
    responsive: false,
    reorderableRows: false,
    dataKey: 'user_access_token_id',
    sortField: 'user_access_token_created_at',
    sortOrder: 'desc',
    customSort: false,
    checkboxSelection: false,
    stateKey: 'activeDeviceInfo',
    columnResizeMode: ResizeType.EXPAND,
    hideStatusFilter: true,
    columns: [
        TableColumnUtil.makeStringField('user_access_token_device_type', 'App Type'),
        TableColumnUtil.makeStringField('user_access_token_device_version', 'App Version'),
        TableColumnUtil.makeStringField('user_access_token_device_model', 'Device Model'),
        TableColumnUtil.makeStringField('user_access_token_device_manufacturer', 'Device Manufacturer'),
        TableColumnUtil.makeStringField('user_access_token_os_version', 'OS Version'),
        TableColumnUtil.makeDateTimeField('user_access_token_created_at', 'Logged In At'),
        TableColumnUtil.makeDateTimeField('user_access_token_logout_at', 'Logged Out At'),
    ],
    header: {
        show: true,
        title: 'Device Info',
        globalFilter: true,
        globalFilterFields: [
            { field: 'user_access_token_device_version', type: FilterType.STRING },
            { field: 'user_access_token_device_model', type: FilterType.STRING },
            { field: 'user_access_token_device_manufacturer', type: FilterType.STRING },
            { field: 'user_access_token_os_version', type: FilterType.STRING },
        ],
        buttons: [
        ],
    },
    toggleOptions: {
        show: true,
        columns: [
            {
                field: 'user_access_token_device_model',
                selected: true
            },
            {
                field: 'user_access_token_device_manufacturer',
                selected: true
            },
            {
                field: 'user_access_token_os_version',
                selected: true
            },
            {
                field: 'user_access_token_device_version',
                selected: true
            },
            {
                field: 'user_access_token_created_at',
                selected: true
            },
            {
                field: 'user_access_token_logout_at',
                selected: true
            },
        ],
    },
    actions: {
        show: false,
        hardDelete: false
    },
    exportOptions: {
        show: true,
        csv: { show: true, type: ExportType.CUSTOM, action: ExportActionType.EXPORT_CSV },
        pdf: { show: true, type: ExportType.CUSTOM, action: ExportActionType.EXPORT_PDF },
        excel: { show: true, type: ExportType.CUSTOM, action: ExportActionType.EXPORT_EXCEL },
    },
};

